
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 155385"}},[_c('g',{attrs:{"data-name":"Group 134914"}},[_c('g',{attrs:{"data-name":"Rectangle 110904","fill":"rgba(38,166,154,0)","stroke":"#ef5350","stroke-width":"2"}},[_c('rect',{attrs:{"width":"32","height":"32","rx":"16","stroke":"none"}}),_c('rect',{attrs:{"x":"1","y":"1","width":"30","height":"30","rx":"15","fill":"none"}})]),_c('g',{attrs:{"fill":"none","stroke":"#ef5350","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/arrow-right"}},[_c('path',{attrs:{"d":"M11.041 11.041l9.917 9.917"}}),_c('path',{attrs:{"data-name":"Vector","d":"M20.959 11.041l-9.917 9.917"}})])])])])
          )
        }
      }
    